import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import t, { partial } from '../../../util/translation/translation';
import Api from '../../../util/api';

const s = partial('shared');
const p = partial('EventsPage');

const CommentModal = ({
  selectedParticipantForComment: participant,
  getPaticipants,
  handleCloseModal,
  isWaitlist,
}) => {
  const savedNotes = participant?.additionalNotes || '';
  const [notes, setNotes] = useState(savedNotes);
  const [saving, setSaving] = useState(false);
  const unchanged = notes.trim() === savedNotes.trim();
  const fullName = [participant?.firstname, participant?.lastname]
    .filter(Boolean)
    .join(' ');

  const save = async () => {
    if (saving || unchanged) return;
    setSaving(true);
    try {
      if (isWaitlist) {
        await Api.events.addWaitingParticipantNotes(
          { additionalNotes: notes },
          participant.id
        );
      } else {
        await Api.events.addAdditionalNotes(
          { additionalComment: notes },
          participant.id
        );
      }
      toast.success(p('notesSaved'));
      handleCloseModal();
      getPaticipants();
    } catch {
      toast.error(p('failedToAddNotes'));
      setSaving(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    save();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      save();
    }
  };

  return (
    <form className="notes-modal" onSubmit={handleSubmit}>
      <div className="notes-modal__participant">
        <span className="notes-modal__avatar" aria-hidden>
          {(participant?.firstname?.[0] || '').toUpperCase()}
          {(participant?.lastname?.[0] || '').toUpperCase()}
        </span>
        <div className="notes-modal__who">
          <span className="notes-modal__name">
            {fullName}
            {participant?.type === 'GUEST' && (
              <span className="notes-modal__tag">{s('guest')}</span>
            )}
          </span>
          {participant?.phoneNumber && (
            <small className="text-muted">{participant.phoneNumber}</small>
          )}
        </div>
      </div>

      <textarea
        className="notes-modal__input"
        value={notes}
        onChange={(event) => setNotes(event.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={p('notesPlaceholder')}
        aria-label={t('EventsPage.addNotes')}
        rows={5}
        autoFocus
      />
      <small className="notes-modal__hint">{p('saveShortcut')}</small>

      <div className="notes-modal__footer">
        <Button
          type="button"
          color="secondary"
          size="sm"
          className="mb-0"
          onClick={handleCloseModal}
        >
          {s('cancel')}
        </Button>
        <Button
          type="submit"
          color="primary"
          size="sm"
          className="mb-0"
          disabled={saving || unchanged}
        >
          {s('save')}
        </Button>
      </div>
    </form>
  );
};

CommentModal.propTypes = {
  selectedParticipantForComment: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    phoneNumber: PropTypes.string,
    type: PropTypes.string,
    additionalNotes: PropTypes.string,
  }).isRequired,
  getPaticipants: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isWaitlist: PropTypes.bool,
};

CommentModal.defaultProps = {
  isWaitlist: false,
};

export default CommentModal;
